import { TAResponseProps } from 'types/TextAnalysis'
import { Tag } from '../Types'
import { AppDispatch, storeInstance } from 'redux/store'
import { sentimentSummary } from 'redux/thunks/TextAnalysis'
import { resetUserFilters } from 'redux/slices/TextAnalysis'

export type ClickEvent = React.MouseEvent<HTMLElement>
export type KeyPressEvent = React.KeyboardEvent<HTMLElement>
export type SetAnchorMap = React.Dispatch<
  React.SetStateAction<{ [key: string]: HTMLElement | null }>
>

export const handleAddTagIcon = (
  index: number,
  setAnchorElMap: SetAnchorMap,
) => {
  const id = `action-card-${index + 1}`
  const anchroElement = document.getElementById(id?.toString() || '')
  if (anchroElement) {
    setAnchorElMap((prevState) => ({ ...prevState, [index]: anchroElement }))
  }
}

export const closeTagMenu = (index: number, setAnchorElMap: SetAnchorMap) => {
  setAnchorElMap((prevState) => ({ ...prevState, [index]: null }))
}

export const getOwnerType = (owner: { type: string }) => {
  return owner?.type.toLowerCase() || ''
}

export const removeTag = (index: number, tagToRemove: any) => {
  const latestData = storeInstance.getState().textAnalysis.main.data
  const latestTags = latestData[index]?.attributes?.tags
  return latestTags.filter((tag: any) => tag.name !== tagToRemove.name)
}

export const handleAddNewTag = (
  item: TAResponseProps,
  tagToAdd: (string | Tag)[],
): any => {
  const {
    id,
    attributes: { source_id },
  } = item
  return {
    id,
    source_id,
    tags: tagToAdd,
  }
}

export const updateTagsImmediate = (index: any, tagToAdd: (Tag | string)[]) => {
  const latestData = storeInstance.getState().textAnalysis.main.data
  const newTags = [...(latestData[index]?.attributes?.tags || []), tagToAdd]
  return newTags
}

export const loadTabAPIs = (dispatch: AppDispatch, tabId: number): void => {
  switch (tabId) {
    case 0:
      // Contributions tab: load contributions list by resetting filters
      dispatch(resetUserFilters())
      break
    case 1:
      // Themes tab: No-op here; handled inside AIThemes component
      break
    case 2:
    default:
      // Results tab: trigger sentiment summary fetch
      dispatch(sentimentSummary())
      break
  }
}
